import mitt from 'mitt';
import { defineAppPlugin } from '/app/utils/app'

export const Emitter = mitt();

export const bus = (type, ...args) => {
    Emitter.emit(type, ...args);
};

export const on = (type, handler) => {
    Emitter.on(type, handler);

    return () => {
        Emitter.off(type, handler);
    };
};

export const once = (type, handler) => {
    // Detaching before the call keeps a handler that re-emits its own event
    // from re-entering, and leaves nothing registered afterwards. The previous
    // form appended a bound `off` that removed only the handler, so every
    // `once()` left a dead entry on the type for the life of the page.
    const wrapped = (...args) => {
        Emitter.off(type, wrapped);
        handler(...args);
    };

    Emitter.on(type, wrapped);

    return () => {
        Emitter.off(type, wrapped);
    };
};

export const bindEmit = (...args) => Emitter.emit.bind(Emitter, ...args);

export const install = () => {};

export default Emitter;
